(function (Drupal) {
  Drupal.behaviors.bloqueEncabezadoyFormBuscar = {
    attach: function (context, settings) {
      // Primero verificamos si existe el formulario
      var searchForm = context.querySelector("#search-form");

      if (searchForm) {
        var searchLabel = searchForm.querySelector('label[for="edit-keys"]');

        if (searchLabel) {
          searchLabel.style.display = "none";
        }
      }

      // Buscar todos los list-group-item que contengan resultados de búsqueda
      var searchResults = context.querySelectorAll(".list-group-item");

      searchResults.forEach(function (result) {
        // Obtener el enlace del h3
        var originalLink = result.querySelector("h3 a");

        if (originalLink) {
          // Crear el nuevo enlace "Leer más"
          var readMoreLink = document.createElement("a");
          readMoreLink.href = originalLink.href;
          readMoreLink.textContent = "Leer más";
          readMoreLink.className = "leer-mas"; // Añade una clase para estilos

          // Crear un párrafo para contener el enlace
          var readMoreP = document.createElement("div");
          readMoreP.appendChild(readMoreLink);

          // Insertar después del último párrafo
          result.appendChild(readMoreP);
        }
      });
    },
  };
})(Drupal);
